import { defineMessages } from 'react-intl';

export default defineMessages({
  flashFees: 'Flashloan fees',
  flashloan: 'Flashloan',
  maxSlippage: 'Max. slippage',
  custom: 'Custom',
  APYChange: 'APY change',
  newHealthFactor: 'New health factor',
});
